import { Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core'
import { Store } from '@ngrx/store'
import { SubscriptionsService, SubscriptionStatus } from '../../../../services/subscriptions'
import { BehaviorSubject, EMPTY, take } from 'rxjs'
import { CommonModule } from '@angular/common'
import { ActivatedRoute, Router } from '@angular/router'
import { eps } from '../../../../services/url.service'
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ToastrService } from 'ngx-toastr'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { SubscriptionInvoiceComponent } from '../../subscribers/subscription-invoice/subscription-invoice.component'
import { Business } from '../../../../store/business/business.state'
import { UtilsService } from '../../../../services/utils.service'

@Component({
  selector: 'app-licence-history',
  imports: [CommonModule, ReactiveFormsModule, CapitalizePipe],
  templateUrl: './licence-history.component.html',
  styleUrl: './licence-history.component.scss'
})
export class LicenceHistoryComponent implements OnInit {
  @ViewChild('addLicenceModal') addLicenceModal!: TemplateRef<any>
  @ViewChild('changeStatusModal') changeStatusModal!: TemplateRef<any>
  store = inject(Store)
  modalService = inject(NgbModal)
  toastr = inject(ToastrService)
  route = inject(ActivatedRoute)
  router = inject(Router)
  eps = eps
  trialDaysForm = new FormControl(0, { nonNullable: true })
  subscriptionStatus = SubscriptionStatus
  subscriptionStatusValues = Object.values(SubscriptionStatus)
  subscriptionStatusForm = new FormControl(SubscriptionStatus.Active, { nonNullable: true })
  subscriptionDisplayId = ''
  subscriptionId = ''
  subscriptions = inject(SubscriptionsService)
  subscription$ = new BehaviorSubject<any>(EMPTY)
  totalLicences = 0
  fb = inject(FormBuilder)
  form!: FormGroup
  SubscriptionInvoiceComponent = SubscriptionInvoiceComponent

  constructor(private utilsService: UtilsService) {}

  ngOnInit() {
    const subscriptionDisplayId = this.route.snapshot.paramMap.get('id')
    if (subscriptionDisplayId) this.subscriptionDisplayId = subscriptionDisplayId
    else this.router.navigate([eps.superAdmin.subscribersPath])

    this.subscriptions
      .getsubscriptionHistory(this.subscriptionDisplayId)
      .pipe(take(1))
      .subscribe(res => {
        this.subscriptionId = res.subscription.id
        this.subscriptionStatusForm.setValue(
          res.subscription.subscriptionStatus as SubscriptionStatus
        )
        this.trialDaysForm.setValue(res.subscription.trialDays)
        this.totalLicences = Number(res?.subscription?.licences?.[0]?.totalLicences ?? 0) ?? 0
        this.initializeForm()
        this.subscription$.next(res)
      })
  }

  initializeForm() {
    this.form = this.fb.group({
      subscriptionId: [this.subscriptionId, Validators.required],
      addedLicences: [0, [Validators.required, Validators.min(1)]]
    })
  }

  openModal(modal: TemplateRef<any>) {
    this.initializeForm()
    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }

  closeModal() {
    this.modalService.dismissAll()
  }

  addLicence() {
    const { subscriptionId, addedLicences } = this.form.value
    this.subscriptions
      .updateTrialLicenseLimit(subscriptionId, addedLicences + this.totalLicences)
      .pipe(take(1))
      .subscribe({
        next: updated => {
          this.subscription$.next(updated)
          this.closeModal()
        },
        error: err => {
          this.toastr.error(err.error.message, err.error.error)
        }
      })
  }

  updateStatus() {
    this.subscriptions
      .updateSubscriptionStatus(
        this.subscriptionId,
        this.subscriptionStatusForm.value ?? ('' as SubscriptionStatus)
      )
      .pipe(take(1))
      .subscribe({
        next: updated => {
          this.subscription$.next(updated)
          this.subscriptionStatusForm.setValue(updated.subscriptionStatus as SubscriptionStatus)
          this.closeModal()
        },
        error: err => {
          this.toastr.error(err.error.message, err.error.error)
        }
      })
  }

  updateTrialDays() {
    this.subscriptions
      .updateTrialDays(this.subscriptionId, this.trialDaysForm.value)
      .pipe(take(1))
      .subscribe({
        next: updated => {
          this.subscription$.next(updated)
          this.trialDaysForm.setValue(updated.trialDays)
          this.closeModal()
        },
        error: err => {
          this.toastr.error(err.error.message, err.error.error)
        }
      })
  }

  openInvoiceModal(
    component: any,
    licence: any,
    business: Business,
    adminBusiness: Business,
    subscription: any
  ) {
    const modalRef = this.modalService.open(component, {
      size: 'xl',
      centered: true
    })
    // apne actual subscription/invoice data ke hisaab se map karo
    modalRef.componentInstance.invoiceData = licence
    modalRef.componentInstance.businessData = business
    modalRef.componentInstance.adminBusinessData = adminBusiness
    modalRef.componentInstance.subscriptionData = subscription
    // modalRef.componentInstance.invoiceData = {
    //   licence,
    //   business,
    //   adminBusiness
    // }
  }

  isAdmin(): boolean {
    return this.utilsService.isAdmin()
  }
}
